import React, { memo, useMemo, useCallback, useState } from 'react';
import svgToMiniDataURI from 'mini-svg-data-uri';
import { isEqual } from 'lodash';

import MarkerIconMedium from './DeviceMarkerIconMedium';
import Marker from 'components/Marker';

export enum MAP_MARKERS {
  BASE = 20,
  HOVER = 22,
  ACTIVE = 21,
}

interface IProps {
  arrowColor?: string;
  outline?: string;
  statusColor: string;
  name: string;
  active?: boolean;
  position: {
    lat: number;
    lng: number;
  };
  onClick?: (deviceId: string) => void;
  onMouseOver?: () => void;
  onMouseOut?: () => void;
  deviceId?: string;
  heading?: number;
}

const DeviceMarker: React.FC<IProps> = ({
  active = false,
  arrowColor,
  heading,
  deviceId,
  name,
  onClick,
  onMouseOver,
  onMouseOut,
  outline,
  position,
  statusColor,
}) => {
  const icon = useMemo(() => {
    const getMarkerIcon = MarkerIconMedium;
    return svgToMiniDataURI(getMarkerIcon({ name, statusColor, active, outline, arrowColor, heading }));
  }, [arrowColor, name, statusColor, outline, heading, active]);

  const [isHovered, setIsHovered] = useState(false);
  const [hideTitle, setHideTitle] = useState(false);

  const anchor = useMemo(() => {
    return new google.maps.Point(24, 41);
  }, []);

  const handleClick = useCallback(() => {
    if (onClick) {
      onClick(deviceId);
    }
  }, [deviceId, onClick]);

  const handleMouseOver = useCallback(() => {
    if (deviceId) {
      setIsHovered(true);
    }
    setHideTitle(true);
    if (onMouseOver) {
      onMouseOver();
    }
  }, [deviceId, onMouseOver]);

  const handleMouseOut = useCallback(() => {
    if (deviceId) {
      setIsHovered(false);
    }
    setHideTitle(false);
    if (onMouseOut) {
      onMouseOut();
    }
  }, [deviceId, onMouseOut]);

  return (
    <Marker
      title={hideTitle ? '' : 'Device Marker'}
      icon={icon}
      anchor={anchor}
      position={position}
      zIndex={active ? MAP_MARKERS.ACTIVE : isHovered ? MAP_MARKERS.HOVER : MAP_MARKERS.BASE}
      onClick={handleClick}
      onMouseOver={handleMouseOver}
      onMouseOut={handleMouseOut}
    />
  );
};

export default memo(DeviceMarker, isEqual);
